import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';
import { notification } from 'antd';
import qs from 'qs';
import { environment } from 'environments/environment';
import Helpers from 'utils/Helpers';

const AxiosInstance = axios.create({
  baseURL: environment.serverUrl,
  headers: {
    'Content-Type': 'application/json'
  }
});

AxiosInstance.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    // Get token dynamically for each request
    const token = Helpers.getToken();
    if (token) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${token}`
      };
    }

    config.paramsSerializer = (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    };

    return config;
  },
  async (error) => {
    notification.error({
      message: 'error.message',
      description: 'In Request Error'
    });

    return Promise.reject(error);
  }
);

AxiosInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    const currentToken = Helpers.getToken();
    if (!currentToken && response.data.token) {
      localStorage.setItem('user', JSON.stringify(response.data));
    }

    return response;
  },
  (error) => {
    // Handle cases where error.response doesn't exist (CORS, network errors)
    if (!error.response) {
      return Promise.reject(error);
    }

    const { status, statusText, data } = error.response;

    // if (status === 400) {
    //   notification.error({
    //     message: status,
    //     description: data.message
    //   });
    // }

    if (status === 401 && statusText === 'UNAUTHORIZED') {
      const currentToken = Helpers.getToken();
      if (currentToken) {
        localStorage.removeItem('user');
        window.location.href = '/';
      }

      notification.error({
        message: `${status} ${statusText}`,
        description: data.message
      });
    }

    if (status === 404) {
      // Completely disable 404 notifications
      return Promise.reject(error);
    }

    if (status === 500) {
      const currentToken = Helpers.getToken();
      // if (currentToken) {
      //   localStorage.removeItem('user');
      //   window.location.href = '/';
      // }

      notification.error({
        message: 'Server is facing issues',
        description: 'Please contact backend team'
      });
    }

    return Promise.reject(error);
  }
);

export default AxiosInstance;
